import { render, staticRenderFns } from "./RecoveryPassword.vue?vue&type=template&id=20b844fa&"
import script from "./RecoveryPassword.vue?vue&type=script&lang=js&"
export * from "./RecoveryPassword.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryPassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports